import {
    allowMergedViewService,
    AllowMergedViewServiceRequest,
    setTimeProfileService,
    SetTimeProfileServiceRequest,
} from 'owa-timeprofile-service';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { getUserMailboxInfo } from 'owa-client-ids';
import { getEmailAddressForSetTimeProfileService } from '../utils/getEmailAddressForSetTimeProfileService';

/**
 * Makes a call to server to enable Merged View for Availability settings
 */
export default async function enableMergedViewAvailabilitySetting(
    mergedViewEnabledAccountSmtpAddress: string
) {
    let allowMergedViewRequest: AllowMergedViewServiceRequest = {
        // We need to pass in the smtp address of the primary account
        TargetEmailAddress: getUserMailboxInfo().primarySmtpAddress,
    };

    let allowMergedViewResponse = await allowMergedViewService(
        allowMergedViewRequest,
        mergedViewEnabledAccountSmtpAddress
    );

    const consumerEmailAddress = getEmailAddressForSetTimeProfileService(
        mergedViewEnabledAccountSmtpAddress
    );

    if (allowMergedViewResponse && isSuccessStatusCode(allowMergedViewResponse.status)) {
        let setTimeProfileRequest: SetTimeProfileServiceRequest = {
            TimeProfileInformation: {
                ConsumerEmailAddress: consumerEmailAddress,
                ConsumerId: '-1',
                MergedViewEnabled: true,
            },
            ConsumerHash: 'abc', // this will be a dummy string until the server side implementation is complete for it
        };

        return await setTimeProfileService(setTimeProfileRequest);
    }

    return allowMergedViewResponse;
}
